import { createAction } from 'deox';
import { CLOSE_ACCOUNT_MODAL, OPEN_ACCOUNT_MODAL } from './types';

export const openMyAccountModal = createAction(OPEN_ACCOUNT_MODAL, (res) => (params) => res(params));

export const closeAccountModal = createAction(CLOSE_ACCOUNT_MODAL);
